var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlagNo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F0F0F0",
  d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D80027",
  d: "M.551 20.174a16 16 0 0 0 5.71 8.52v-8.52zM14.609 31.94Q15.297 32 16 32c7.393 0 13.613-5.014 15.449-11.826h-16.84zM31.449 11.826C29.613 5.014 23.393 0 16 0q-.703 0-1.391.06v11.766zM6.261 3.306a16 16 0 0 0-5.71 8.52h5.71z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052B4",
  d: "M31.865 13.913H12.522V.38a15.9 15.9 0 0 0-4.174 1.565v11.968H.135a16.1 16.1 0 0 0 0 4.174h8.213v11.968a15.9 15.9 0 0 0 4.174 1.565V18.087h19.343a16.2 16.2 0 0 0 0-4.174"
})));
export default SvgFlagNo;